<template>
    <el-form-item label="交易类型">
        <el-select style="width:120px;" v-model="type" placeholder="交易类型" @change="payTypeSelectChange">
            <el-option label="扫码" :value="0"></el-option>
            <el-option label="非扫码" :value="1"></el-option>
        </el-select>
        <el-select v-model="channel" collapse-tags multiple placeholder="交易渠道">
            <template v-if="type === 1">
                <el-option label="刷卡" :value="0" v-if="!isProfit"></el-option>
                <el-option label="pos刷卡" :value="1" v-else></el-option>
<!--                <el-option label="其他" :value="-2"></el-option>-->
            </template>
            <template v-else>
                <div v-if="!isProfit">
                    <el-option label="微信" :value="1"></el-option>
                    <el-option label="支付宝" :value="2"></el-option>
                    <el-option label="银联二维码" :value="5"></el-option>
                </div>
                <div v-else>
                    <el-option label="微信支付" :value="2"></el-option>
                    <el-option label="支付宝支付" :value="3"></el-option>
                    <el-option label="银联扫码" :value="6"></el-option>
                </div>
            </template>
        </el-select>
    </el-form-item>
</template>

<script>
export default {
  name: 'paymentType',
  props: {
    payType: {
      type: Number,
      default: 0
    },
    payChannel: {
      type: String,
      default: '1, 2, 5'
    },
    isProfit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      type: 0,
      channel: [1, 2, 5]
    }
  },
  mounted () {
    this.channel = this.payChannel.split(',')
    this.channel = this.channel.map(function (item) {
      item = parseInt(item)
      return item
    })
  },
  watch: {
    type (val, oldVal) {
      this.$emit('getPayType', val)
    },
    channel (val, oldVal) {
      var value = val.join(',')
      this.$emit('getPayChannel', value)
    }
  },
  methods: {
    payTypeSelectChange (value) {
      if (value === 0 && !this.isProfit) {
        this.channel = [1, 2, 5]
      }
      if (value === 0 && this.isProfit) {
        this.channel = [2, 3, 6]
      }
      if (value === 1 && !this.isProfit) {
        this.channel = [0]
      }
      if (value === 1 && this.isProfit) {
        this.channel = [1]
      }
    }
  }
}
</script>

<style scoped>

</style>
